import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { A } from '../../../../../../assets/elements';
import PostcodeAddress from '../../../../PostcodeAddress/PostcodeAddress';
import ManualAddress from '../../../../ManualAddress/ManualAddress';
import SavedAddress from '../../../../SavedAddress/SavedAddress';
import ContinueButton from '../../Elements/ContinueButton';
import {
  addressBookToggle,
  goToNextQuickBookStep,
  setDeliveryAddress, setRecipientInfo,
} from '../../../../../store/actions';
import CheckBoxInput from '../../../../Inputs/CheckBoxInput';
import ColumnWrapper from '../../Elements/ColumnWrapper';

const addressTypeConstants = {
  POSTCODE: 'postcode',
  MANUAL: 'manual',
  SAVED: 'saved',
};

const addressErrorKeys = [
  'addressOne',
  'city',
  'country',
  'zip',
];

const DeliveryAddress = ({
  setDone,
  done,
  checkCustoms,
  defAddress,
  deliveryType,
  addressData,
  setAddressData,
  addressErrors,
  setAddressErrors,
  addToAddressBook,
  setAddToAddressBook,
}: any) => {
  const dispatch = useDispatch();

  const address = useSelector((state: any) => state.order.deliveryAddress);
  const details = useSelector((state: any) => state.order.recipientDetails);
  const { country: collCountry } = useSelector((state: any) => state.order.collectionAddress);

  const [addressType, setAddressType] = useState<any>(addressTypeConstants.POSTCODE);

  const [detailsComplete, setDetailsComplete] = useState(false);

  useEffect(() => {
    if (deliveryType === 'inbound') {
      setAddressData({
        ...addressData,
        ...defAddress,
        country: defAddress.country !== '' ?
          defAddress.country : addressData.country
      });
    } else {
      setAddressData({
        company: '',
        addressOne: '',
        addressTwo: '',
        addressThree: '',
        city: '',
        country: 'GB',
        zip: '',
      });
    }
  }, [deliveryType]);

  useEffect(() => {
    let complete = true;

    addressErrorKeys.forEach((key: any) => {
      if (addressData[key] === '') {
        complete = false;
      }
    });

    setDetailsComplete(complete);
  }, [addressData]);

  useEffect(() => {
    if (collCountry !== '' && addressData.country !== '') {
      checkCustoms(collCountry, addressData.country);
    }
  }, [collCountry, addressData.zip, addressData.country]);

  useEffect(() => {
    setDone(detailsComplete);

    dispatch(setDeliveryAddress(addressData));
    dispatch(addressBookToggle(addToAddressBook));
  }, [detailsComplete]);

  useEffect(() => {
    if (done) {
      dispatch(setDeliveryAddress(addressData));
      dispatch(addressBookToggle(addToAddressBook));
    }
  }, [done, addressData.country, addressData.zip]);

  const handleCheckboxChange = () => {
    setAddToAddressBook(!addToAddressBook);
  };

  // useEffect(() => {
  //   dispatch(setDeliveryAddress(addressData));
  //   dispatch(addressBookToggle(addToAddressBook));
  // }, [addressData, addToAddressBook]);

  const handleMobileChange = (value: any) => {
    dispatch(setRecipientInfo({
      ...details,
      phone: value,
      name: '',
    }));
  };

  return (
    <>
      <ColumnWrapper heading="Address">
        <>
          {
            addressType === addressTypeConstants.POSTCODE && (
              <>
                <PostcodeAddress
                  address={addressData}
                  setAddress={setAddressData}
                  errors={addressErrors}
                  setErrors={setAddressErrors}
                  country={true}
                />
                <AddressBookRow>
                  <CheckBoxInput
                    checked={addToAddressBook}
                    label="Add to address book"
                    onChange={handleCheckboxChange}
                  />
                </AddressBookRow>
              </>
            )
        }
          {
          addressType === addressTypeConstants.MANUAL && (
            <>
              <ManualAddress
                address={addressData}
                setAddress={setAddressData}
                errors={addressErrors}
                setErrors={setAddressErrors}
                wrapper={false}
              />
              <AddressBookRow>
                <CheckBoxInput
                  checked={addToAddressBook}
                  label="Add to address book"
                  onChange={handleCheckboxChange}
                />
              </AddressBookRow>
            </>
          )
        }
          {
          addressType === addressTypeConstants.SAVED && (
            <SavedAddress
              address={addressData}
              setAddress={setAddressData}
              setMobileNumber={handleMobileChange}
            />
          )
        }

          <LinksRow>
            {
            addressType !== addressTypeConstants.SAVED && (
            <LinkButton
              onClick={() => setAddressType(addressTypeConstants.SAVED)}
            >
              Select from address book
            </LinkButton>
            )
          }
            {
            addressType !== addressTypeConstants.POSTCODE && (
            <LinkButton
              onClick={() => setAddressType(addressTypeConstants.POSTCODE)}
            >
              Search by postcode
            </LinkButton>
            )
          }
            {
            addressType !== addressTypeConstants.MANUAL && (
            <LinkButton
              onClick={() => setAddressType(addressTypeConstants.MANUAL)}
            >
              Enter manually
            </LinkButton>
            )
          }
          </LinksRow>
        </>
      </ColumnWrapper>
    </>
  );
};

const LinksRow = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const LinkButton = styled(A)`
  margin-right: 24px;

  &:last-child {
    margin-right: 0;
  }
`;

const SavedAddressLine = styled.div`
  color: ${({ theme }: any) => theme.colors.LightGrey};
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
`;

const AddressBookRow = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 32px;
`;

export default DeliveryAddress;
